// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1FZ-D","overflowing":"ReadFullNote_overflowing__1evEE"};